import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { useUtils as useI18nUtils } from '@core/libs/i18n'

export default function useIconList() {
    const tableColumns = [
        { key: 'path', label: 'Icon', sortable: false },
        { key: 'name', label: 'Name', sortable: false },
        { key: 'is_active', label: 'Status', sortable: false },
        { key: 'action', label: '#', sortable: false }
    ];
    const getLocalSite = JSON.parse(localStorage.getItem('site'))
    const icons = ref([])
    const totalIcons = ref(0)
    const type = ref('')
    const iconData = ref(null)
    const isIconFormSidebarActive = ref(false)
    const refIconListTable = ref(null)
    const perPage = ref(10)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const statusFilter = ref(null)
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)
    const toast = useToast()
    const dataMeta = computed(() => {
    const localItemsCount = refIconListTable.value ? refIconListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalIcons.value,
        }
    })

    const getType = (eventType) => {
        type.value = eventType
    }

    const refetchData = () => {
        refIconListTable.value.refresh()
        fetchIconData();
    }

    watch([currentPage, perPage, searchQuery, statusFilter, type], () => {
        refetchData()
    })

    const fetchIconData = (ctx, callback) => {
        const offset = perPage.value*(currentPage.value-1);

        store
            .dispatch('app-event/getEventIcons', {
                limit: perPage.value,
                offset:offset,
                keywords: searchQuery.value,
                sites_id: getLocalSite.id,
                event_type: type.value
            })
            .then(response => {
                icons.value = response.data.data
                totalIcons.value = response.data.total
            })
            .catch((error) => {
                toast({
                    component: ToastificationContent,
                    props: {
                        title: "Error fetching Icon' list",
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                    },
                })
            })
    }

    const resolveCatagoryStatusVariant = status => {
        if (status ) return 'success'
        if (!status ) return 'secondary'
        return 'primary'
    }

    const resolveCatagoryStatusnameVariant = status => {
        if (status) return 'Active'
        if (!status) return 'Inactive'
        return 'primary'
    }

    const updateIcon = (data) => {
        iconData.value = data
        isIconFormSidebarActive.value = true
    }

    const deleteData = (id) => {
        store.dispatch('app-event/deleteEventIcon',id).then(response=>{
            toast({
                component: ToastificationContent,
                props: {
                title: "Delete Success",
                icon: 'AlertTriangleIcon',
                variant: 'success',
                },
            })
            fetchIconData();
        }).catch((error)=>{
            toast({
                component: ToastificationContent,
                props: {
                    title: "Error Delete Food Category",
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                },
            })
        })
    }

    return {
        tableColumns,
        refetchData,
        searchQuery,
        fetchIconData,
        sortBy,
        isSortDirDesc,
        dataMeta,
        refIconListTable,
        currentPage,
        statusFilter,
        perPage,
        perPageOptions,
        resolveCatagoryStatusVariant,
        resolveCatagoryStatusnameVariant,
        updateIcon,
        isIconFormSidebarActive,
        deleteData,
        type,
        icons,
        totalIcons,
        getType,
        iconData,
    }
}